import(/* webpackMode: "eager" */ "C:\\xampp\\htdocs\\enthioshub\\enthioshub\\frontend\\src\\app\\become-organizer\\page.tsx");
